import {
  MatchTeamContainer,
  SetScore,
  OrgLogoContainer,
  OrgName,
  TeamScore,
  TeamScoresContainer,
  TrackScore,
} from "./styles";
import { selectRosterDisplayName } from "selectors/Roster";
import { Match, getWinningRosterIds } from "model/Match/Match";
import {
  getMatchPartScores,
  getRosterDisplayScore,
} from "model/Match/MatchScore";
import {
  getRosterIdOrPlaceholder,
  isPlaceholderRoster,
  Roster,
} from "model/Roster/Roster";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  match: Match;
  roster: Roster;
  tournamentId: string;
  showScores: boolean;
  showTrackScores: boolean;
}

export const ListMatchTeam = ({
  match,
  roster,
  tournamentId,
  showScores,
  showTrackScores,
}: Props) => {
  const rosterId = getRosterIdOrPlaceholder(roster);
  const isPlaceholder = isPlaceholderRoster(roster);
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );

  const rosterScore = getRosterDisplayScore(match, rosterId);
  const isWinningRoster = getWinningRosterIds(match)?.includes(rosterId);
  const partScores = getMatchPartScores(match, rosterId, showTrackScores);

  return (
    <MatchTeamContainer>
      <OrgLogoContainer>
        {!isPlaceholder && (
          <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
        )}
      </OrgLogoContainer>
      <OrgName>{displayName}</OrgName>
      <TeamScoresContainer>
        {!isPlaceholder && showScores && (
          <>
            <TeamScore isWinningTeam={isWinningRoster ?? false}>
              {rosterScore ?? "-"}
            </TeamScore>
            {!!partScores && (
              <>
                {partScores.map((part) =>
                  part.type === "Set" ? (
                    <SetScore isWinningTeam={part.winner ?? false}>
                      {part.score}
                    </SetScore>
                  ) : (
                    <TrackScore isWinningTeam={part.winner ?? false}>
                      {part.score}
                    </TrackScore>
                  )
                )}
              </>
            )}
          </>
        )}
      </TeamScoresContainer>
    </MatchTeamContainer>
  );
};
